import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "@src/environments/environment";

import { Observable } from 'rxjs/Observable';
import { IResponse } from "@bt/shared";
import { AuthService } from './auth.service';
import { HttpParams } from "@angular/common/http/src/params";

const apiUrl = environment.apiUrl;

@Injectable()
export class ApiService {

    constructor(private http: HttpClient, private authService: AuthService) { }

    public getAnonym<T>(url: string): Observable<IResponse<T>> {
        return this.http.get<IResponse<T>>(apiUrl + url);
    }

    public get<T>(
       url: string,
       params?: HttpParams | { [param: string]: string | string[] }
    ): Observable<IResponse<T>> {
        return this.http.get<IResponse<T>>(
            apiUrl + url,
            {
                headers: this.getAuthorizationHeaders(),
                params: params,
              });
    }

    public postAnonym<T>(url: string, body: any): Observable<IResponse<T>> {
        return this.http.post<IResponse<T>>(apiUrl + url, body);
    }

    public post<T>(url: string, body: any): Observable<IResponse<T>> {
        return this.http.post<IResponse<T>>(apiUrl + url, body, { headers: this.getAuthorizationHeaders() });
    }

    public putAnonym<T>(url: string, body: any): Observable<IResponse<T>> {
        return this.http.put<IResponse<T>>(apiUrl + url, body);
    }

    public put<T>(url: string, body: any): Observable<IResponse<T>> {
        return this.http.put<IResponse<T>>(apiUrl + url, body, { headers: this.getAuthorizationHeaders() });
    }

    public upload<T>(url: string, formData: any): Observable<IResponse<T>> {
        //  this.http.post<IResponse<T>>(apiUrl + url, body, { headers: this.getAuthorizationHeaders() });
         return this.http.post<IResponse<T>>(apiUrl + url, formData, {headers: this.getAuthorizationHeaders()});
    }

    private getAuthorizationHeaders(): any {
        let accessToken="";
        if(this.authService.authData){
            accessToken=this.authService.authData.accessToken;
        }
        return {
            "Authorization": `Bearer ${accessToken}`
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/api.service.ts